import * as React from 'react';
import { connect } from 'react-redux';
import { Container, Form, FormFeedback, FormGroup, Input, Label, Modal, ModalBody, ModalFooter } from 'reactstrap';
import { bindActionCreators, Dispatch } from 'redux';

import * as BeneficiarySearchAction from '../../actions/BeneficiarySearch';

import * as AdditionsApi from '../../api/additions';
import * as PartnersApi from '../../api/partners';

import Localization from '../../config/localization';

import { GetAddress } from '../../lib/address';
import { CustomError } from '../../lib/error';
import Notifications from '../../lib/notifications';
import {
  Capitalize,
  GetCapitalizeAllWords,
  GetMonthFromSeason,
  GetName,
  GetUtilityTypeFromLocation,
  IsNaturalGas,
  TimeStampToDate,
  ToFloat,
  ToNumber,
  ToString
} from '../../lib/utils';
import { CNPValidation } from '../../lib/validator';

import BackButton from '../../components/BackButton';
import Client from '../../components/Client';
import Loader from '../../components/Loader';
import CloseSvg from '../../components/Svg/close';
import TrashSvg from '../../components/Svg/trash';
import WarningSvg from '../../components/Svg/warning';

import './BeneficiaryAdd.scss';
import DatePicker from '../../components/DatePicker';
import { getQuantumAmount } from '../../lib/money';
import { MIN_ADDITION_DATE } from '../../constants/addition';
import { formatDate, getCurrentDate } from '../../lib/date';
import { LOCALITY_SECTORS, SHOW_LOCALITY_SECTOR_CODE } from '../../constants/locality';
import { isAccountType } from '../../lib/user';
import { ADMIN } from '../../constants/accountType';
import { DEFAULT_CAEN_CODE_FOR_ASSOCIATION } from '../../constants/association';

type IProps =
  BeneficiaryAddAddition.IProps
  & ReturnType<typeof mapDispatchToProps>
  & ReturnType<typeof mapStateToProps>;

const DATE_FORMAT = 'YYYYMM';

class BeneficiaryAddAddition extends React.Component<IProps, BeneficiaryAddAddition.IState> {
  state: BeneficiaryAddAddition.IState = {
    loading: false,
    loadingMessage: '',

    partner: undefined,

    additionId: 0,
    additionType: GetUtilityTypeFromLocation(this.props.location),
    approvalDocumentData: TimeStampToDate(),
    approvalDocumentNo: '',
    familyMembersNo: 1,
    firstName: '',
    formWasSubmitted: false,
    lastName: '',
    localBudgetAmount: 0,
    memberFamilyIncome: 0,
    personalIdentificationNumber: '',
    startDate: getCurrentDate(DATE_FORMAT),
    stateBudgetAmount: 0,
    totalFamilyIncome: 0,
    localitySector: ToString(this.props.Auth && this.props.Auth.localitySector, LOCALITY_SECTORS[0]),

    additionExist: false,

    ranges: undefined,

    confirmDeleteModal: false,
    confirmModal: false,
    successModal: false,

    previouseAidId: undefined,
    previousePersonalIdentificationNumber: undefined

  };

  async componentDidMount() {
    $('#stateBudgetAmount').selectmenu({ change: this._setStateBudgetAmount });
    $('#localitySector').selectmenu({ change: this._setLocalitySector });

    return Promise.all([this._getBeneficiaryFromApi(), this._getAdditionRange()]);
  }

  _ranges = () => {
    let ranges: Additions.IAdditionsRange[] = [];

    if (this.state.ranges) {
      if (this.state.familyMembersNo) {
        ranges = this.state.ranges.filter(range => range.personType === ToString(this.state.familyMembersNo));
      }
      if (!ranges.length) {
        ranges = this.state.ranges.filter(range => !range.personType);
      }
    }

    return ranges;
  };

  renderStateBudgetAmounts = () => {
    const naturalGas = IsNaturalGas(this.props.location);

    return this._ranges().map(item => {
      const value = naturalGas ? item.additionSumGn : item.additionSumEe;

      return (
        <option key={item.additionRangeId} value={value}>
          {value}
        </option>
      );
    });
  };

  renderMonth = () => {
    return (
      <div className="force-wrap mt-5">
        <FormGroup className="w-30">
          <Label className="text-nowrap" for="startDate-button">
            {Localization.beneficiaryAddAdditionStartDateLabel}
          </Label>
          <fieldset className="eon-select">
            <DatePicker
              name="startDate"
              id="startDate"
              value={this.state.startDate}
              onChange={this._setStartDate}
              className="eon-input-text"
              minDate={MIN_ADDITION_DATE}
            />
            <FormFeedback tooltip>{Localization.beneficiaryAddStartDateError}</FormFeedback>
          </fieldset>
        </FormGroup>
        <hr />
      </div>
    );
  };

  renderFamilyMembersForm = () => {
    return (
      <div>
        <Label className="mt-4 w-100">
          <h5 className="eon-title eon-darkgrey">{Localization.beneficiaryAddFamilyMemberData}</h5>
          <h6 className="eon-title eon-middle-grey">{Localization.beneficiaryAddFamilyMemberDataInfo}</h6>
        </Label>
        <div className="mt-4 d-flex">
          <FormGroup className="w-50 pr-3 mr-auto">
            <Label className="text-nowrap" for="familyMembersNo">
              {Localization.beneficiaryAddFamilyMembersNo}
            </Label>
            <Input
              type="number"
              step="1"
              min="1"
              name="familyMembersNo"
              id="familyMembersNo"
              value={this.state.familyMembersNo}
              onChange={this._setFamilyNumber}
              className={`eon-input-text`}
            />
            <FormFeedback className="mr-5" tooltip>
              {Localization.beneficiaryAddFamilyMembersNoError}
            </FormFeedback>
          </FormGroup>
          <FormGroup className="w-30 pr-3 remove-arrow mx-auto">
            <Label className="text-nowrap" for="memberFamilyIncome">
              {Localization.beneficiaryAddMemberFamilyIncome}
            </Label>
            <Input
              type="number"
              step="0.01"
              min="0"
              name="memberFamilyIncome"
              id="memberFamilyIncome"
              value={this.state.memberFamilyIncome}
              onChange={this._setIncome}
              onBlur={this._updateTotalFamilyIncome}
              onWheel={this._stopScroll}
              className={`eon-input-text`}
            />
            <FormFeedback className="mr-3" tooltip>
              {Localization.beneficiaryAddMemberFamilyIncomeError}
            </FormFeedback>
          </FormGroup>
          <Label className="mb-auto mt-5 text-nowrap">{Localization.or}</Label>
          <FormGroup className="w-30 pl-3 remove-arrow ml-auto">
            <Label className="text-nowrap" for="totalFamilyIncome">
              {Localization.beneficiaryAddTotalFamilyIncome}
            </Label>
            <Input
              type="number"
              step="0.01"
              min="0"
              name="totalFamilyIncome"
              id="totalFamilyIncome"
              value={this.state.totalFamilyIncome}
              onChange={this._setIncome}
              onBlur={this._updateMemberFamilyIncome}
              onWheel={this._stopScroll}
              className={`eon-input-text`}
            />
            <FormFeedback tooltip>{Localization.beneficiaryAddTotalFamilyIncomeError}</FormFeedback>
          </FormGroup>
        </div>
      </div>
    );
  };

  renderFinancier = () => {
    return (
      <div className="position-relative">
        <Label className="mt-4 w-100">
          <h5 className="eon-title eon-darkgrey">{Localization.beneficiaryAddAdditionFinancialData}</h5>
          <h6 className="eon-title eon-middle-grey">{Localization.beneficiaryAddAdditionFinancialDataInfo}</h6>
        </Label>
        <div className="mt-4 d-flex">
          <FormGroup className="w-50 pr-2 mr-auto">
            <Label className="text-nowrap" for="approvalDocumentNo">
              {Localization.beneficiaryAddApprovalDocumentNo}
            </Label>
            <Input
              type="text"
              name="approvalDocumentNo"
              id="approvalDocumentNo"
              value={this.state.approvalDocumentNo}
              onChange={this._setValue}
              className={`eon-input-text ${!this._approvalDocumentNoValidation() && this.state.formWasSubmitted ? 'is-field-error' : ''} `}
              invalid={!this._approvalDocumentNoValidation() && this.state.formWasSubmitted}
            />
            <FormFeedback tooltip>{Localization.beneficiaryAddApprovalDocumentNoError}</FormFeedback>
          </FormGroup>
          <FormGroup className="w-50 pl-2 remove-arrow ml-auto">
            <Label className="text-nowrap" for="approvalDocumentData">
              {Localization.beneficiaryAddApprovalDocumentData}
            </Label>
            <Input
              type="date"
              name="approvalDocumentData"
              id="approvalDocumentData"
              value={this.state.approvalDocumentData}
              onChange={this._setDate}
              className={`eon-input-text position-relative calendar-field ${!this.state.approvalDocumentData && this.state.formWasSubmitted ? 'is-field-error' : ''
                } `}
              invalid={!this.state.approvalDocumentData && this.state.formWasSubmitted}
            />
            <FormFeedback tooltip>{Localization.beneficiaryAddApprovalDocumentDataError}</FormFeedback>
          </FormGroup>
        </div>
        <FormGroup className="mt-4 w-50 pr-2 d-inline-block remove-arrow">
          <Label className="text-nowrap" for="stateBudgetAmount">
            {Localization.beneficiaryAddStateBudgetAmount}
          </Label>
          <fieldset className="eon-select large eon-red">
            <Input
              type="select"
              name="stateBudgetAmount"
              id="stateBudgetAmount"
              value={this.state.stateBudgetAmount}
              onChange={() => undefined}
              className="d-none eon-select large eon-red"
              invalid={!this._stateBudgetAmountValidation() && this.state.formWasSubmitted}
            >
              {this.renderStateBudgetAmounts()}
              <option value={Localization.beneficiaryAddDefaultStateAmountValue}>
                {Localization.beneficiaryAddDefaultStateAmountValue}
              </option>
            </Input>
            <FormFeedback className="mr-4" tooltip>
              {Localization.beneficiaryAddStateBudgetAmountError}
            </FormFeedback>
          </fieldset>
        </FormGroup>
        <FormGroup className="pl-2 remove-arrow d-inline-block w-50">
          <Label className="text-nowrap" for="localBudgetAmount">
            {Localization.beneficiaryAddLocalBudgetAmount}
          </Label>
          <Input
            type="number"
            step="0.01"
            min="0"
            name="localBudgetAmount"
            id="localBudgetAmount"
            value={this.state.localBudgetAmount}
            onChange={this._setLocalBudgetAmount}
            className="eon-input-text"
          />
          <FormFeedback tooltip>{Localization.beneficiaryAddLocalBudgetAmountError}</FormFeedback>
        </FormGroup>
        {this._localBudgetAmountValidation() ? (
          <FormGroup className="pl-2 d-inline-block position-absolute total">
            <Label className="text-nowrap" for="localBudgetAmount">
              {`${Localization.beneficiaryAddTotalAmount} ${getQuantumAmount(this.state)}`}
            </Label>
          </FormGroup>
        ) : null}
      </div>
    );
  };

  nameReplacer = new RegExp('<|>|&', 'gmi')
  _setName = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.persist();

    event.target.value = ToString(event.target.value).replace(this.nameReplacer, '');

    return this._setValue(event);
  }

  renderBeneficiary = () => {
    return (
      <div>
        <Label className="w-100">
          <h5 className="eon-title eon-darkgrey">{Localization.beneficiaryAddPersonalData}</h5>
          <h6 className="eon-title eon-middle-grey">{Localization.beneficiaryAddPersonalDataInfo}</h6>
        </Label>
        <div className="mt-4 d-flex">
          <FormGroup className="w-50 pr-2 mr-auto">
            <Label className="text-nowrap" for="lastName">
              {Localization.beneficiaryAddLastName}
            </Label>
            <Input
              type="text"
              name="lastName"
              id="lastName"
              disabled={this.state.isMonthClosed}
              value={this.state.lastName}
              onChange={this._setName}
              onBlur={this._capitalize}
              className={`eon-input-text ${!this.state.lastName && this.state.formWasSubmitted ? 'is-field-error' : ''} `}
              invalid={!this.state.lastName && this.state.formWasSubmitted}
            />
            <FormFeedback tooltip>{Localization.beneficiaryAddLastNameError}</FormFeedback>
          </FormGroup>
          <FormGroup className="w-50 pl-2 ml-auto">
            <Label className="text-nowrap" for="firstName">
              {Localization.beneficiaryAddFirstName}
            </Label>
            <Input
              type="text"
              name="firstName"
              id="firstName"
              disabled={this.state.isMonthClosed}
              value={this.state.firstName}
              onChange={this._setName}
              onBlur={this._capitalize}
              className={`eon-input-text ${!this.state.firstName && this.state.formWasSubmitted ? 'is-field-error' : ''} `}
              invalid={!this.state.firstName && this.state.formWasSubmitted}
            />
            <FormFeedback tooltip>{Localization.beneficiaryAddFirstNameError}</FormFeedback>
          </FormGroup>
        </div>

        <FormGroup className="mt-4 remove-arrow">
          <Label className="text-nowrap" for="personalIdentificationNumber">
            {Localization.beneficiaryAddPersonalIdentificationNumber}
          </Label>
          <Input
            type="number"
            name="personalIdentificationNumber"
            id="personalIdentificationNumber"
            disabled={this.state.isMonthClosed}
            value={this.state.personalIdentificationNumber}
            onChange={this._setPersonaIdentificationNumber}
            onWheel={this._stopScroll}
            className={`eon-input-text ${!CNPValidation(this.state.personalIdentificationNumber) && this.state.formWasSubmitted ? 'is-field-error' : ''
              } `}
            invalid={!CNPValidation(this.state.personalIdentificationNumber) && this.state.formWasSubmitted}
          />
          <FormFeedback tooltip>{Localization.beneficiaryAddPersonalIdentificationNumberError}</FormFeedback>
        </FormGroup>

        {this._showLocalitySector() ? <FormGroup className={`mt-4 w-50 remove-arrow d-block`}>
          <Label className="text-nowrap" for="localitySector">
            {Localization.beneficiaryAddLocalitySector}
          </Label>
          <fieldset className="eon-select large eon-red">
            <Input
              type="select"
              name="localitySector"
              id="localitySector"
              value={this.state.localitySector}
              onChange={() => undefined}
              className={`eon-select large eon-input-text`}
              invalid={!this.state.localitySector && this.state.formWasSubmitted}
              disabled={!isAccountType(ADMIN, this.props.Auth)}
            >
              {LOCALITY_SECTORS.map((val) => <option key={val} value={val}>
                {Localization.beneficiaryAddLocalitySector} {val}
              </option>)}
            </Input>
          </fieldset>
        </FormGroup> : null}
      </div>
    );
  };


  renderForm = () => {
    return (
      <div className="position-relative">
        {this.state.partner && (
          <Client
            partner={this.state.partner}
            showUtilityType={true}
            isNaturalGas={IsNaturalGas(this.props.location)}
            extraClassName="client-card position-absolute bg-eon-ultra-light-grey"
          />
        )}

        <Form className="my-5 w-60" onSubmit={this._doSubmit}>
          {this.renderBeneficiary()}
          {this.renderFamilyMembersForm()}

          {this.renderFinancier()}

          <button className="mt-5 eon-button bg-eon-red eon-white">
            <span
              className="px-3">{this.state.additionId ? Localization.beneficiaryAddModify : Localization.beneficiaryAddSave}</span>
          </button>

          {this.state.previouseAdditionId ? <button className="eon-button bg-eon-lightgrey eon-middle-grey" onClick={this._onModifyAdditionCancel}>
            <span className="px-3">{Localization.beneficiaryAddCancel}</span>
          </button> : null}
        </Form>
      </div>
    );
  };

  render() {
    return (
      <Container className="beneficiary-add px-5 py-4 my-4">
        <BackButton />

        <Loader loading={this.state.loading} loadingMessage={this.state.loadingMessage} />

        <div className="text-left my-4 d-flex flex-wrap">
          <h4 className="eon-title eon-red force-wrap">{Localization.beneficiaryAddAdditionStartDateText}</h4>

          {this.renderMonth()}

          <div className="force-wrap mt-4">
            <h4 className="eon-title eon-red">{Localization.beneficiaryAddAdditionBeneficiaryData}</h4>

            {this.renderForm()}
          </div>

          <button
            className={`eon-button ${!this._showDelete() ? 'bg-eon-white eon-middle-grey' : 'bg-eon-white eon-red'}`}
            disabled={!this._showDelete()}
            onClick={this._showDeleteModal}
          >
            <span className="px-3">
              {Localization.beneficiaryAddDelete}
              <TrashSvg className="my-auto mx-1 align-content-center" />
            </span>
          </button>
        </div>

        <Modal centered isOpen={this.state.confirmModal} toggle={this._closeConfirmModal}>
          <ModalBody className="px-4">
            <h4 className="eon-title eon-darkgrey text-nowrap mt-4">{Localization.beneficiaryAddModalConfirmHead}</h4>
            <h5 className="eon-copy  eon-darkgrey-75 mt-4">{Localization.beneficiaryAddModalConfirmLabel}</h5>
            <div className="mt-3">
              <h5 className="eon-title eon-darkgrey mt-1">{`${GetName({
                firstName: this.state.firstName,
                lastName: this.state.lastName
              })} ${this.state.personalIdentificationNumber}`}</h5>
              <h5 className="eon-title eon-middle-grey">
                {GetAddress(this.state.partner && this.state.partner.address)}
              </h5>
              <h5 className="eon-title eon-darkgrey mt-2">
                {`${getQuantumAmount(this.state)} ${Localization.currency}`}
              </h5>
              <h5
                className="eon-title eon-darkgrey eon-datepicker">{formatDate(this.state.startDate)}</h5>
              <h5 className="eon-title eon-darkgrey">
                {IsNaturalGas(this.props.location)
                  ? Localization.beneficiaryAddNaturalGasLabel
                  : Localization.beneficiaryAddElectricEnergyLabel}
              </h5>
            </div>
          </ModalBody>
          <ModalFooter className="my-4 border-0 justify-content-start">
            <button className="eon-button bg-eon-red eon-white mx-5" onClick={this._confirmSubmit}>
              <span className="px-3">{Localization.beneficiaryAddModalConfirmButtonSend}</span>
            </button>
            <button className="eon-button bg-eon-lightgrey eon-middle-grey mx-4" onClick={this._closeConfirmModal}>
              <span className="px-3">{Localization.beneficiaryAddModalConfirmButtonCancel}</span>
            </button>
          </ModalFooter>
        </Modal>

        <Modal centered isOpen={this.state.confirmDeleteModal} toggle={this._closeDeleteModal}>
          <ModalBody className="px-5 mx-5">
            <WarningSvg className="position-absolute m-3" />
            <h4 className="eon-title eon-darkgrey text-nowrap mt-4">
              {Localization.formatString(
                Localization.beneficiaryAddModalDeleteHead,
                Localization.Months[GetMonthFromSeason(this.state.startDate)]
              )}
            </h4>
            <div className="mt-4">
              <h5 className="eon-title eon-darkgrey mt-1">
                {`${GetName({
                  firstName: this.state.firstName,
                  lastName: this.state.lastName
                })} ${this.state.personalIdentificationNumber}`}
              </h5>
              <h5 className="eon-title eon-middle-grey">
                {GetAddress(
                  this.state.partner &&
                  this.state.partner.consumptionPoints &&
                  this.state.partner.consumptionPoints[0] &&
                  this.state.partner.consumptionPoints[0].address
                )}
              </h5>
              <h5 className="eon-title eon-darkgrey mt-2">
                {`${getQuantumAmount(this.state)} ${Localization.currency}`}
              </h5>
              <h5 className="eon-title eon-middle-grey">
                {IsNaturalGas(this.props.location)
                  ? Localization.beneficiaryAddNaturalGasLabel
                  : Localization.beneficiaryAddElectricEnergyLabel}
              </h5>
            </div>
          </ModalBody>
          <ModalFooter className="my-4 border-0 justify-content-start">
            <button className="eon-button bg-eon-red eon-white mx-5" disabled={!this._showDelete()}
              onClick={this._deleteAddition}>
              <span className="px-3">{Localization.beneficiaryAddModalDeleteButtonDelete}</span>
            </button>

            <button className="eon-button bg-eon-white eon-middle-grey ml-5 mr-auto c-pointer"
              onClick={this._closeDeleteModal}>
              <CloseSvg className="my-auto mx-1 align-baseline" />
              <span
                className="eon-middle-grey underline eon-copy">{Localization.beneficiaryAddModalDeleteButtonCancel}</span>
            </button>
          </ModalFooter>
        </Modal>
      </Container>
    );
  }

  _capitalize = (event: React.FocusEvent<HTMLInputElement>) => {
    event.preventDefault();

    return this.setState({
      firstName: GetCapitalizeAllWords(this.state.firstName),
      lastName: Capitalize(this.state.lastName)
    });
  };

  _onModifyAdditionCancel = () => {
    this.setState((previousState => ({
      ...previousState,
      previouseAdditionId: undefined,
      previousePersonalIdentificationNumber: undefined,
      additionExist: !!previousState.previouseAdditionId,
      additionId: previousState.previouseAdditionId || 0,
      personalIdentificationNumber: previousState.previousePersonalIdentificationNumber || ''
    })));
  };

  _setPersonaIdentificationNumber = async (event: React.ChangeEvent<HTMLInputElement>) => {
    event.persist();

    if (this.state.stateBudgetAmount === 0 && this.state.additionId)
      await this.setState(prevState => ({
        ...prevState,
        previouseAdditionId: prevState.additionId,
        previousePersonalIdentificationNumber: prevState.personalIdentificationNumber,
        additionId: 0,
        additionExist: false
      }));

    return this._setValue(event);
  };

  _stopScroll = (event: React.WheelEvent<HTMLInputElement>) => {
    if (event) event.preventDefault();
  };

  _setDate = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();

    const target = event.currentTarget || event.target || {};

    const match = ToString(target.value).match(/([0-9]*)-?/g);

    return this.setState({ approvalDocumentData: ToString(match && match.join('')) });
  };

  _setLocalitySector = (event: Event) => {
    event.preventDefault();

    const element = event.target || undefined;

    const localitySector = ToString(element && $(element).val());

    return this.setState({ localitySector });
  };

  _setStateBudgetAmount = (event: Event) => {
    event.preventDefault();

    const element = event.target || undefined;

    const value = element ? ToFloat(ToString($(element).val())) : 0;

    return this.setState({ stateBudgetAmount: value > -1 ? value : 0 });
  };

  _setLocalBudgetAmount = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();

    const element = event.currentTarget || event.target || {};

    const num = ToFloat(element.value);

    const value = num > 0 ? num : -num;

    return this.setState({ localBudgetAmount: element.value === '' ? '' : value });
  };

  _setValue = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();

    const element = event.currentTarget || event.target || {};

    return this.setState(prevState => ({ ...prevState, [element.id]: element.value }));
  };

  _setStartDate = async (event: React.ChangeEvent<HTMLInputElement>) => {
    event.persist();

    await this._setValue(event);

    await this._updateStateBudgetAmount(0);

    await this._getAdditionRange();
    await this._getAddition();
  };

  _setFamilyNumber = async (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();

    const element = event.currentTarget || event.target || {};

    const value = element.value === '' ? '' : ToNumber(element.value) > 1 ? ToNumber(element.value) : 1;

    await this.setState({ familyMembersNo: value });

    await Promise.all([
      this._setIncome({
        currentTarget: {
          id: 'memberFamilyIncome',
          value: ToString(this.state.memberFamilyIncome)
        },
        preventDefault: () => undefined
      } as React.ChangeEvent<HTMLInputElement>),

      this._setIncome({
        currentTarget: {
          id: 'totalFamilyIncome',
          value: ToString(this.state.totalFamilyIncome)
        },
        preventDefault: () => undefined
      } as React.ChangeEvent<HTMLInputElement>)
    ]);

    if (value) {
      await Promise.all([this._updateTotalFamilyIncome(), this._updateMemberFamilyIncome()]);
    }

    return this._updateStateBudgetAmount();
  };

  _updateStateBudgetAmount = async (fixedValue?: number) => {
    let value = Localization.beneficiaryAddDefaultStateAmountValue;

    if (typeof fixedValue !== 'undefined') {
      value = fixedValue;
    } else {
      const foundRange = this._ranges().find(range => {
        return this.state.memberFamilyIncome >= ToFloat(range.rangeDown) && this.state.memberFamilyIncome <= ToFloat(range.rangeUp);
      });


      if (foundRange && IsNaturalGas(this.props.location)) {
        value = foundRange.additionSumGn;
      } else if (foundRange) {
        value = foundRange.additionSumEe;
      }

    }

    await this.setState({ stateBudgetAmount: value });

    return $('#stateBudgetAmount')
      .selectmenu()
      .selectmenu('refresh');
  };

  _updateTotalFamilyIncome = async () => {
    const value = ToFloat(this.state.memberFamilyIncome) * ToNumber(this.state.familyMembersNo);

    await this.setState({ totalFamilyIncome: ToFloat(value.toFixed(2)) });

    return this._updateStateBudgetAmount();
  };

  _updateMemberFamilyIncome = async () => {
    const value = ToFloat(this.state.totalFamilyIncome) / ToNumber(this.state.familyMembersNo);

    await this.setState({ memberFamilyIncome: ToFloat(value.toFixed(2)) });

    return this._updateStateBudgetAmount();
  };

  _setIncome = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();

    const element = event.currentTarget || event.target || {};

    const value = ToFloat(element.value) > 0 || !element.value ? element.value : 0;

    return this.setState(prevState => ({ ...prevState, [element.id]: value }));
  };

  _getAdditionRange = async () => {
    try {
      if (!this.state.startDate) return undefined;

      const response = await AdditionsApi.GetAdditionsRange({
        month: this.state.startDate,
        utilityType: this.state.additionType.toUpperCase()
      });

      return this.setState({ ranges: response.data || [] });
    } catch (error) {
      return Notifications.error(error && error.message);
    }
  };

  _showDelete = () => {
    if (
      !this.state.additionId ||
      getQuantumAmount(this.state) <= 0 ||
      this.state.additionExported
    ) {
      return false;
    }

    return true;
  };

  _confirmSubmit = async () => {
    try {
      await this.setState({ loading: true });

      const data = {
        additionId: this.state.additionId,
        additionType: this.state.additionType,
        approvalDocumentData: this.state.approvalDocumentData,
        approvalDocumentNo: this.state.approvalDocumentNo,
        familyMembersNo: ToNumber(this.state.familyMembersNo),
        firstName: GetCapitalizeAllWords(this.state.firstName || this.state.partner && this.state.partner.firstName),
        lastName: Capitalize(this.state.lastName || this.state.partner && this.state.partner.lastName),
        localBudgetAmount: ToFloat(this.state.localBudgetAmount),
        memberFamilyIncome: ToFloat(this.state.memberFamilyIncome),
        personalIdentificationNumber: this.state.personalIdentificationNumber || this.state.partner && this.state.partner.fiscalNumber,
        startDate: this.state.startDate,
        stateBudgetAmount: ToFloat(this.state.stateBudgetAmount),
        partnerCode: this.state.partner && this.state.partner.partnerCode,
        type: 0,
        localityCode: this.state.partner && this.state.partner.address.localityCode,
        consumptionPoint: ToString(
          this.state.partner &&
          this.state.partner.consumptionPoints &&
          this.state.partner.consumptionPoints[0] &&
          this.state.partner.consumptionPoints[0].consumptionPointCode
        ),
        localitySector: this._showLocalitySector() ? this.state.localitySector : undefined,
      } as unknown as Additions.IAdditions;

      if (this.state.additionId) {
        await AdditionsApi.UpdateAddition(this.state.additionId, data);
      } else {
        await AdditionsApi.CreateAddition(data);
      }

      await this.setState({ loading: false, successModal: true });

      await this._closeConfirmModal();

      Notifications.success(Localization.beneficiaryAddModalSuccessHead);

      this.props.ClearSearch();

      return this.props.history.goBack();
    } catch (error) {
      Notifications.error(error && error.message);

      return this.setState({ loading: false });
    }
  };

  _getAddition = async (getLast?: boolean): Promise<void> => {
    try {
      const consumptionPoint =
        this.state.partner &&
        this.state.partner.consumptionPoints &&
        this.state.partner.consumptionPoints[0];

      const consumptionPointCode = consumptionPoint && consumptionPoint.consumptionPointCode;

      if (!consumptionPointCode || !this.state.partner) return undefined;

      await this.setState({
        loading: true,
        localityCode: consumptionPoint && consumptionPoint.address && consumptionPoint.address.localityCode
      });

      const currentAdditionId = ToNumber(this.props.BeneficiarySearch && this.props.BeneficiarySearch.additiondId);
      const currentAdditionCNP = ToString(this.props.BeneficiarySearch && this.props.BeneficiarySearch.additionCNP);

      const response = await AdditionsApi.GetAdditions(consumptionPointCode, { month: !getLast ? this.state.startDate : undefined });

      const isAssociation = this.state.partner && this.state.partner.consumptionPoints.find(
        consumptionPoint => consumptionPoint && consumptionPoint.caenCode === DEFAULT_CAEN_CODE_FOR_ASSOCIATION
      );

      const foundAddition = response.data && response.data.length && response.data.find(addition => addition && !!(ToNumber(addition.additionId) === currentAdditionId || addition.personalIdentificationNumber === currentAdditionCNP || (addition.isForced && !isAssociation)));

      if (!foundAddition) {
        throw new CustomError(Localization.Errors['1015'], '1015');
      }

      const data = {
        additionId: ToNumber(foundAddition.additionId),
        additionType: ToString(foundAddition.additionType) || this.state.additionType,
        approvalDocumentData: TimeStampToDate(ToNumber(foundAddition.approvalDocumentData)),
        approvalDocumentNo: ToString(foundAddition.approvalDocumentNo),
        familyMembersNo: ToNumber(foundAddition.familyMembersNo),
        firstName: GetCapitalizeAllWords(foundAddition.firstName || this.state.partner.firstName),
        lastName: Capitalize(foundAddition.lastName || this.state.partner.lastName),
        loading: false,
        localBudgetAmount: ToFloat(foundAddition.localBudgetAmount),
        memberFamilyIncome: ToFloat(foundAddition.memberFamilyIncome),
        personalIdentificationNumber: ToString(ToNumber(foundAddition.personalIdentificationNumber || this.state.partner.fiscalNumber)),
        startDate: ToString(foundAddition.startDate) || this.state.startDate,
        stateBudgetAmount: ToFloat(foundAddition.stateBudgetAmount),
        totalFamilyIncome: ToFloat(ToNumber(foundAddition.familyMembersNo) * ToFloat(foundAddition.memberFamilyIncome)),
        localitySector: foundAddition.localitySector || this.state.localitySector,
        localityCode: foundAddition.localityCode || this.state.localityCode
      } as BeneficiaryAddAddition.IState;

      data.additionExist = !!(data.additionId && getQuantumAmount(data));

      for (const key in data) {
        if (data[key] === undefined) {
          delete data[key];
        }
      }

      await this.setState(data);

      $('#localitySector')
        .selectmenu()
        .selectmenu('refresh');


      $('#stateBudgetAmount')
        .selectmenu()
        .selectmenu('refresh');

      return undefined;
    } catch (error) {
      if (error.code === '1015' && !getLast) {
        if (!this.state.additionId) {
          return this._getAddition(true);
        } else {
          const data = {
            additionExist: this.state.additionExist,
            additionExported: this.state.additionExported,
            familyMembersNo: this.state.familyMembersNo,
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            memberFamilyIncome: this.state.memberFamilyIncome,
            personalIdentificationNumber: this.state.personalIdentificationNumber,
            totalFamilyIncome: this.state.totalFamilyIncome,
            startDate: this.state.startDate || ''
          };

          await this._setDefaultState(data);
        }
      } else if (error.code !== '1015') {
        Notifications.error(error && error.message);

        window.scrollTo(0, 0);
      }

      return this.setState({ loading: false });
    }
  };

  _closeDeleteModal = () => {
    return this.setState({ confirmDeleteModal: false });
  };

  _showDeleteModal = () => {
    return this.setState({ confirmDeleteModal: true });
  };

  _setDefaultState = (data: Partial<BeneficiaryAddAddition.IState> = {} as BeneficiaryAddAddition.IState) => {
    return this.setState({
      additionExist: data.additionExist || false,
      additionExported: data.additionExported || '',
      additionId: data.additionId || 0,
      approvalDocumentData: data.approvalDocumentData || TimeStampToDate(),
      approvalDocumentNo: data.approvalDocumentNo || '',
      confirmDeleteModal: data.confirmDeleteModal || false,
      familyMembersNo: data.familyMembersNo || 1,
      firstName: data.firstName || '',
      formWasSubmitted: data.formWasSubmitted || false,
      lastName: data.lastName || '',
      loading: data.loading || false,
      localBudgetAmount: data.localBudgetAmount || 0,
      memberFamilyIncome: data.memberFamilyIncome || 0,
      personalIdentificationNumber: data.personalIdentificationNumber || '',
      startDate: data.startDate || '',
      stateBudgetAmount: data.stateBudgetAmount || 0,
      totalFamilyIncome: data.totalFamilyIncome || 0
    });
  };

  _deleteAddition = async () => {
    try {
      if (!this._showDelete()) {
        return this._closeDeleteModal();
      }
      await this.setState({ loading: true });

      await AdditionsApi.DeleteAddition(this.state.additionId);

      await this._setDefaultState();

      return Notifications.success(Localization.beneficiaryAddDeletedSuccess);
    } catch (error) {
      Notifications.error(error && error.message);

      return this.setState({ loading: false });
    }
  };

  _getBeneficiaryFromApi = async () => {
    try {
      await this.setState({ loading: true });

      const response = await PartnersApi.GetPartner({
        search: this.props.match.params.consumptionPoint,
        utilityType: this.state.additionType,
        type: 'addition'
      });

      const partner = (response.data && response.data[0]) || {};

      if (partner) {
        await this.setState({
          firstName: GetCapitalizeAllWords(partner.firstName),
          lastName: Capitalize(partner.lastName),
          personalIdentificationNumber: this.state.personalIdentificationNumber || partner.fiscalNumber,
          partner,
        });
      }

      await this._getAddition(true);

      return this.setState({ loading: false });
    } catch (error) {
      window.scrollTo(0, 0);

      Notifications.error(error && error.message);

      return this.setState({ loading: false });
    }
  };

  _startDateValidation = () => {
    if (!this.state.startDate) {
      return false;
    }

    return true;
  };

  _approvalDocumentNoValidation = () => {
    return new RegExp('.*[0-9].*').test(this.state.approvalDocumentNo);
  };

  _localBudgetAmountValidation = () => {
    return ToNumber(this.state.localBudgetAmount) > 0;
  };

  _stateBudgetAmountValidation = () => {
    if (this.state.additionExist) {
      return true;
    } else if (this.state.localBudgetAmount > 0) {
      return true;
    }

    return ToFloat(this.state.stateBudgetAmount) > 0;
  };

  _validateStateBudgetAmount = (value: number = 0) => {
    if (isNaN(Number(value))) {
      return false;
    } else if (value < 0) {
      return false;
    }
    return true;
  };

  _isValid = () => {
    if (!CNPValidation(this.state.personalIdentificationNumber)) {
      return false;
    } else if (!this._validateStateBudgetAmount(this.state.stateBudgetAmount)) {
      return false;
    } else if (!this.state.firstName) {
      return false;
    } else if (!this.state.lastName) {
      return false;
    } else if (!this._startDateValidation()) {
      return false;
    } else if (!this._approvalDocumentNoValidation()) {
      return false;
    } else if (!this._stateBudgetAmountValidation()) {
      return false;
    }

    return true;
  };

  _closeConfirmModal = () => {
    return this.setState({ confirmModal: false });
  };

  _doSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const data = { formWasSubmitted: true } as BeneficiaryAddAddition.IState;

    if (this._isValid()) {
      data.confirmModal = true;
    }

    return this.setState(data);
  };

  _showLocalitySector = () => {
    return this.state.localityCode === SHOW_LOCALITY_SECTOR_CODE;
  };
}

const mapStateToProps = (state: General.Store) => ({ BeneficiarySearch: state.BeneficiarySearch, Auth: state.Auth });

const mapDispatchToProps = (dispatch: Dispatch) => ({ ...bindActionCreators({ ...BeneficiarySearchAction }, dispatch) });

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BeneficiaryAddAddition);
